import { Inject, Injectable, Renderer2, RendererFactory2 } from '@angular/core';
import { Router, NavigationEnd, NavigationCancel, NavigationStart, Event, ResolveStart, ActivatedRoute, Params } from '@angular/router';
import { BehaviorSubject, ReplaySubject, Subject } from 'rxjs';
import { first } from 'rxjs/operators';
import { DOCUMENT } from '@angular/common';

@Injectable({
    providedIn: 'root'
})
export class RouteService {

    private previousUrl: string;
    private currentUrl: string;
    private cancelledUrl: string;
    public startUrl: string;
    private resolveStartUrl: string;
    private currentUrlSub: BehaviorSubject<string>;
    public currentUrl$: any;
    private paramsSub: BehaviorSubject<any>;
    private queryParamsSub: BehaviorSubject<any>;
    public params$: any;
    public queryParams$: any;
    private dataSub: BehaviorSubject<any>;
    public data$: any;
    public activatedRoute;
    public activatedRoute$;
    prevLoadedComp: string;
    renderer2: Renderer2;
    public snapshot;

    constructor(private router: Router,
                private route: ActivatedRoute,
                private rendererFactory: RendererFactory2,
                @Inject(DOCUMENT) protected doc) {
        this.renderer2 = rendererFactory.createRenderer(null, null);
        this.currentUrl = this.router.url;
        this.currentUrlSub = new BehaviorSubject(this.currentUrl);
        this.paramsSub = new BehaviorSubject(this.route.snapshot.params);
        this.queryParamsSub = new BehaviorSubject(this.route.snapshot.queryParams);
        this.dataSub = new BehaviorSubject(this.route.snapshot.data);
        this.activatedRoute = new BehaviorSubject(this.route);
        this.currentUrl$ = this.currentUrlSub.asObservable();
        this.params$ = this.paramsSub.asObservable();
        this.queryParams$ = this.queryParamsSub.asObservable();
        this.data$ = this.dataSub.asObservable();
        this.activatedRoute$ = this.activatedRoute.asObservable();

        router.events.subscribe((event: Event) => {
            if (event instanceof NavigationEnd) {
                this.previousUrl = this.currentUrl;
                this.currentUrl = event.urlAfterRedirects ?? event.url;
                this.currentUrlSub.next(this.currentUrl);
                this.cancelledUrl = '';
                // save route params
                let r = this.route;
                while (r.firstChild) r = r.firstChild;
                this.setBodyClass(r.component['componentID'] ?? r.component.name);
                this.activatedRoute.next(r);
                r.params.pipe(first()).subscribe((params: Params) => {
                    this.paramsSub.next(params);
                });
                this.dataSub.next(r.snapshot.data);
                this.queryParamsSub.next(r.snapshot.queryParams);
                this.snapshot = r.snapshot;
            }
            if (event instanceof NavigationCancel && event.url !== '/404') {
                this.cancelledUrl = event.url;
            }
            if (event instanceof NavigationStart) {
                this.startUrl = event.url;
            }
            if (event instanceof ResolveStart) {
                this.resolveStartUrl = event.url;
            }
        });
    }

    public getPreviousUrl() {
        return this.previousUrl;
    }

    public getCurrentUrl() {
        return this.currentUrl;
    }

    public getCancelledUrl() {
        return this.cancelledUrl;
    }

    public getStartUrl() {
        return this.startUrl;
    }

    public getResolveStartUrl() {
        return this.resolveStartUrl;
    }

    private setBodyClass(componentName) {
        componentName = componentName.split(/(?=[A-Z])/).join('-').toLowerCase();
        if (this.prevLoadedComp) {
            this.renderer2.removeClass(this.doc.body, this.prevLoadedComp);
        }
        this.renderer2.addClass(this.doc.body, componentName);
        this.prevLoadedComp = componentName;

    }
}
